import { Phone } from "lucide-react";
import PageHero from "@/components/PageHero";
import Marquee from "@/components/Marquee";
import { Reveal, SectionHeading, GoldButton, GhostButton } from "@/components/Reveal";
import { IMAGES, STEPS, PHONE, PHONE_LINK } from "@/data/site";

const HowItWorks = () => (
  <div data-testid="how-it-works-page">
    <PageHero
      testId="how-it-works-hero"
      kicker="How It Works"
      titleLines={["Six chapters.", "One phone call."]}
      description="From the moment of the accident until your claim is resolved, this is exactly what happens — and the only step that requires anything from you is the first."
      image={IMAGES.rangeRover}
    />

    <section className="mx-auto max-w-5xl px-6 py-28 md:px-10 md:py-36" data-testid="chapters">
      {STEPS.map((step, i) => (
        <Reveal key={step.number} delay={0.02 * i}>
          <div
            data-testid={`chapter-${step.number}`}
            className="group grid grid-cols-[auto_1fr] gap-8 border-b border-white/10 py-14 md:gap-16"
          >
            <span className="font-mono text-4xl text-gold/30 transition-colors duration-500 group-hover:text-gold md:text-6xl">
              {step.number}
            </span>
            <div>
              <h2 className="font-serif text-3xl text-white md:text-4xl">{step.title}</h2>
              <p className="mt-5 max-w-2xl text-base leading-relaxed text-zinc-400">{step.text}</p>
            </div>
          </div>
        </Reveal>
      ))}
    </section>

    <Marquee />

    <section className="mx-auto max-w-7xl px-6 py-28 md:px-10 md:py-36" data-testid="how-it-works-cta">
      <div className="rounded-3xl border border-gold/20 bg-gradient-to-br from-graphite to-obsidian p-10 md:p-20">
        <SectionHeading
          kicker="Chapter One Starts Now"
          title={<>Make the call. <span className="italic text-gold-gradient">We'll write the rest.</span></>}
          description="Emergency accident assistance is available 24 hours, subject to partner availability."
        />
        <Reveal delay={0.2}>
          <div className="mt-12 flex flex-col gap-4 sm:flex-row">
            <GoldButton href={PHONE_LINK} testId="hiw-call-button">
              <Phone className="h-4 w-4" strokeWidth={2} /> Call {PHONE}
            </GoldButton>
            <GhostButton href="/contact" testId="hiw-request-button">
              Request Assistance
            </GhostButton>
          </div>
        </Reveal>
      </div>
    </section>
  </div>
);

export default HowItWorks;
